module.exports = __webpack_public_path__ + "img/sudoku-small.b1a96249.svg";